export default function ({ store, error }) {
    if (!store.getters['user/loggedIn']) {
        return error({ statusCode: 404 })
    }

    if (!store.state.user.user.is_superuser) {
        return error({ statusCode: 404 })
    }
}